import { forwardRef, type ClipboardEvent } from 'react';
import { sanitizePhoneInput } from '../../lib/phone-ru';
import { Input, type InputProps } from '../Input';

export type PhoneInputProps = Omit<InputProps, 'value' | 'onChange' | 'type'> & {
  value: string;
  onChange: (displayValue: string) => void;
};

/** Единый ввод телефона РФ: маска как в CRM-админке; в API уходит {@link normalizePhone} на submit. */
export const PhoneInput = forwardRef<HTMLInputElement, PhoneInputProps>(function PhoneInput(
  { value, onChange, className, invalid, 'aria-invalid': ariaInvalid, ...rest },
  ref
) {
  const isInvalid = Boolean(invalid ?? ariaInvalid);

  const handlePaste = (e: ClipboardEvent<HTMLInputElement>) => {
    const pasted = e.clipboardData.getData('text').replace(/[^\d]/g, '');
    if (!pasted) return;
    e.preventDefault();
    const hasPlus = value.trim().startsWith('+7');
    const cleaned = hasPlus ? pasted.replace(/^7/, '') : pasted;
    const raw = (hasPlus ? '+7 ' : '') + cleaned;
    onChange(sanitizePhoneInput(raw));
  };

  return (
    <Input
      ref={ref}
      type="tel"
      inputMode="tel"
      autoComplete="tel"
      placeholder="+7 (999) 123-45-67"
      aria-invalid={isInvalid}
      invalid={isInvalid}
      className={className ?? undefined}
      value={value}
      onChange={(ev) => onChange(sanitizePhoneInput(ev.target.value))}
      onPaste={handlePaste}
      {...rest}
    />
  );
});
